/**
 * Links a `.badge-art` element to its WebGL handle without importing three.js, so the tilt
 * helpers (and their tests) stay light. The engine itself is in badge-gl.ts (lazy-loaded).
 */
export interface BadgeGlHandle {
    /** In view: draw if needed. */
    show: () => void
    hide: () => void
    /** Size changed: redraw when visible. */
    invalidate: () => void
    /** Pointer position as 0..1 of the badge box → eased 3D rotation. */
    tilt: (px: number, py: number) => void
    /** Ease back to rest. */
    release: () => void
    /** Unlock flourish (≈1.1 s spin), resolves when done. */
    spin: () => Promise<void>
    /** The frame on the canvas is no longer valid (e.g. WebGL context lost): back to the SVG. */
    stale: () => void
    dispose: () => void
}

const handles = new WeakMap<object, BadgeGlHandle>()

export const setBadgeGl = (el: object, h: BadgeGlHandle) => handles.set(el, h)
export const getBadgeGl = (el: object): BadgeGlHandle | undefined => handles.get(el)
export const clearBadgeGl = (el: object) => handles.delete(el)
